module.exports = __webpack_public_path__ + "static/media/Dunsparce_gaussian2.675fa64d.png";